<template>
  <div>
      <SceneList class="marginal" ></SceneList>
  </div>
</template>

<script>
import SceneList from '@/components/SceneList.vue';
export default {
  name: 'SceneListPage',
  components: {
    SceneList
  }
}
</script>